import { render, staticRenderFns } from "./decorativeCom.vue?vue&type=template&id=cc134092&"
import script from "./decorativeCom.vue?vue&type=script&lang=js&"
export * from "./decorativeCom.vue?vue&type=script&lang=js&"
import style0 from "./decorativeCom.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports